'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var utils = require('./utils');

var Plugin = require('./plugin');

module.exports = function (_Plugin) {
  _inherits(Drag, _Plugin);
  /**
   * enable one-finger touch to drag
   * @private
   * @param {Viewport} parent
   * @param {object} [options]
   * @param {string} [options.direction=all] direction to drag (all, x, or y)
   * @param {boolean} [options.wheel=true] use wheel to scroll in y direction (unless wheel plugin is active)
   * @param {number} [options.wheelScroll=1] number of pixels to scroll with each wheel spin
   * @param {boolean} [options.reverse] reverse the direction of the wheel scroll
   * @param {boolean|string} [options.clampWheel] (true, x, or y) clamp wheel (to avoid weird bounce with mouse wheel)
   * @param {string} [options.underflow=center] (top/bottom/center and left/right/center, or center) where to place world if too small for screen
   */


  function Drag(parent, options) {
    _classCallCheck(this, Drag);

    options = options || {};

    var _this = _possibleConstructorReturn(this, (Drag.__proto__ || Object.getPrototypeOf(Drag)).call(this, parent));

    _this.moved = false;
    _this.wheelActive = utils.defaults(options.wheel, true);
    _this.wheelScroll = options.wheelScroll || 1;
    _this.reverse = options.reverse ? 1 : -1;
    _this.clampWheel = options.clampWheel;
    _this.xDirection = !options.direction || options.direction === 'all' || options.direction === 'x';
    _this.yDirection = !options.direction || options.direction === 'all' || options.direction === 'y';

    _this.parseUnderflow(options.underflow || 'center');

    return _this;
  }

  _createClass(Drag, [{
    key: 'parseUnderflow',
    value: function parseUnderflow(clamp) {
      clamp = clamp.toLowerCase();

      if (clamp === 'center') {
        this.underflowX = 0;
        this.underflowY = 0;
      } else {
        this.underflowX = clamp.indexOf('left') !== -1 ? -1 : clamp.indexOf('right') !== -1 ? 1 : 0;
        this.underflowY = clamp.indexOf('top') !== -1 ? -1 : clamp.indexOf('bottom') !== -1 ? 1 : 0;
      }
    }
  }, {
    key: 'down',
    value: function down(e) {
      if (this.paused) {
        return;
      }

      var count = this.parent.countDownPointers();

      if ((count === 1 || count > 1 && !this.parent.plugins['pinch']) && this.parent.parent) {
        var parent = this.parent.parent.toLocal(e.data.global);
        this.last = {
          x: e.data.global.x,
          y: e.data.global.y,
          parent: parent
        };
        this.current = e.data.pointerId;
        return true;
      } else {
        this.last = null;
      }
    }
  }, {
    key: 'move',
    value: function move(e) {
      if (this.paused) {
        return;
      }

      if (this.last && this.current === e.data.pointerId) {
        var x = e.data.global.x;
        var y = e.data.global.y;
        var count = this.parent.countDownPointers();

        if (count === 1 || count > 1 && !this.parent.plugins['pinch']) {
          var distX = x - this.last.x;
          var distY = y - this.last.y;

          if (this.moved || this.xDirection && this.parent.checkThreshold(distX) || this.yDirection && this.parent.checkThreshold(distY)) {
            var newParent = this.parent.parent.toLocal(e.data.global);

            if (this.xDirection) {
              this.parent.x += newParent.x - this.last.parent.x;
            }

            if (this.yDirection) {
              this.parent.y += newParent.y - this.last.parent.y;
            }

            this.last = {
              x: x,
              y: y,
              parent: newParent
            };

            if (!this.moved) {
              this.parent.emit('drag-start', {
                screen: this.last,
                world: this.parent.toWorld(this.last),
                viewport: this.parent
              });
            }

            this.moved = true;
            this.parent.emit('moved', {
              viewport: this.parent,
              type: 'drag'
            });
            return true;
          }
        } else {
          this.moved = false;
        }
      }
    }
  }, {
    key: 'up',
    value: function up() {
      var touches = this.parent.getTouchPointers();

      if (touches.length === 1) {
        var pointer = touches[0];

        if (pointer.last) {
          var parent = this.parent.parent.toLocal(pointer.last);
          this.last = {
            x: pointer.last.x,
            y: pointer.last.y,
            parent: parent
          };
          this.current = pointer.last.data.pointerId;
        }

        this.moved = false;
        return true;
      } else if (this.last) {
        if (this.moved) {
          this.parent.emit('drag-end', {
            screen: this.last,
            world: this.parent.toWorld(this.last),
            viewport: this.parent
          });
          this.last = this.moved = false;
          return true;
        }
      }
    }
  }, {
    key: 'wheel',
    value: function wheel(e) {
      if (this.paused) {
        return;
      }

      if (this.wheelActive) {
        var wheel = this.parent.plugins['wheel'];

        if (!wheel) {
          if (this.xDirection) {
            this.parent.x += e.deltaX * this.wheelScroll * this.reverse;
          }

          if (this.yDirection) {
            this.parent.y += e.deltaY * this.wheelScroll * this.reverse;
          }

          if (this.clampWheel) {
            this.clamp();
          }

          this.parent.emit('wheel-scroll', this.parent);
          this.parent.emit('moved', this.parent);

          if (!this.parent.passiveWheel) {
            e.preventDefault();
          }

          return true;
        }
      }
    }
  }, {
    key: 'resume',
    value: function resume() {
      this.last = null;
      this.paused = false;
    }
  }, {
    key: 'clamp',
    value: function clamp() {
      var decelerate = this.parent.plugins['decelerate'] || {};

      if (this.clampWheel !== 'y') {
        if (this.parent.screenWorldWidth < this.parent.screenWidth) {
          switch (this.underflowX) {
            case -1:
              this.parent.x = 0;
              break;

            case 1:
              this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth;
              break;

            default:
              this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
          }
        } else {
          if (this.parent.left < 0) {
            this.parent.x = 0;
            decelerate.x = 0;
          } else if (this.parent.right > this.parent.worldWidth) {
            this.parent.x = -this.parent.worldWidth * this.parent.scale.x + this.parent.screenWidth;
            decelerate.x = 0;
          }
        }
      }

      if (this.clampWheel !== 'x') {
        if (this.parent.screenWorldHeight < this.parent.screenHeight) {
          switch (this.underflowY) {
            case -1:
              this.parent.y = 0;
              break;

            case 1:
              this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight;
              break;

            default:
              this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
          }
        } else {
          if (this.parent.top < 0) {
            this.parent.y = 0;
            decelerate.y = 0;
          }

          if (this.parent.bottom > this.parent.worldHeight) {
            this.parent.y = -this.parent.worldHeight * this.parent.scale.y + this.parent.screenHeight;
            decelerate.y = 0;
          }
        }
      }
    }
  }, {
    key: 'active',
    get: function get() {
      return this.moved;
    }
  }]);

  return Drag;
}(Plugin);